import React from 'react';
import { StyleSheet, TouchableOpacity, } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
const HowFreeTrialWorksAllPlansButton = ({ onPress, style, alt, isSecondary, onPressIn, onPressOut, }) => (<TouchableOpacity style={[styles.viewAllPlansButton, style]} onPress={onPress} onPressIn={onPressIn} onPressOut={onPressOut}>
    <Text 
// eslint-disable-next-line no-nested-ternary
{...(isSecondary
    ? { Secondary: true }
    : alt
        ? { OnBrand: true }
        : { Primary: true })} Text-16>
      View all plans
    </Text>
  </TouchableOpacity>);
const styles = StyleSheet.create({
    viewAllPlansButton: {
        padding: rem(12),
        alignSelf: 'center',
    },
});
export default HowFreeTrialWorksAllPlansButton;
